import CustomButton from "../../../../components/CustomButton";
import userRoles from "../../../../constants/userRoles";
import SvgIcon from "../../../../helpers/SvgIcon";
import { adminRoutes } from "../../../../router/routesConstants";
import usePermissions from "../../../../router/usePermissions";
import Text from "../../../../styleguide/Text";

function CellsNomenclatureCustomHeader() {
  const { isAuthorized } = usePermissions();

  const goToCreateVerificationZone = () => {
    return `/${adminRoutes.cellsNomenclature}/${adminRoutes.createCellNomenclature}`;
  };

  return (
    <div className="d-flex justify-content-between align-items-center mb-6">
      <Text variant="h3" component="h3" className="card-title">
        Nomenclator celule
      </Text>
      {isAuthorized(userRoles.EDIT_CELL_NOMENCLATURE) && (
        <CustomButton
          variant="contained"
          tooltipTitle="Creeaza"
          navigate={goToCreateVerificationZone()}>
          <SvgIcon type="ADD" />
        </CustomButton>
      )}
    </div>
  );
}

export default CellsNomenclatureCustomHeader;
